import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {useDispatch, useSelector} from 'react-redux';
import Service from "../services/Service";
import {makeStyles} from '@material-ui/core/styles';
import {Grid} from "@material-ui/core";
import {Container} from "@material-ui/core";
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import {getCurrencySymbol} from "./utils/currency";
import PiePortfolio from "./PiePortfolioSVG";
import ChartPortfolio from "./ChartPortfolio";
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from "@material-ui/core/Button";
import Box from '@material-ui/core/Box';
import PortfolioDetails from "./PortfolioDetails";
import {getPortfolio, getPortfolios} from '../store/actions'
import {store} from "../store/store";
import { useHistory } from 'react-router'
import _ from "lodash";
import Hidden from "@material-ui/core/Hidden";
import HorizontalLinearStepper from "./HorizontalLinearStepper";
import EmptyPortfolio from "./EmptyPortfolio";

const useStyles = makeStyles((theme) =>({
    root: {
        minWidth: 275,
        flex: 1,
        color: theme.palette.background.paper,
    },
    pie: {
        flex: 1,
        maxWidth: 374,
        height: 374,
        background: theme.palette.background.paper,
        marginTop: 32,
        marginRight: 32,
        padding: 35,
        borderRadius: 16,
        border: `1px solid ${theme.palette.grey[200] || '#E8ECF2'}`,
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    chart: {
        flex: 1,
        height: 374,
        background: theme.palette.background.paper,
        padding: 35,
        marginTop: 32,
        borderRadius: 16,
        border: `1px solid ${theme.palette.grey[200] || '#E8ECF2'}`,
        [theme.breakpoints.down('sm')]: {
            paddingRight: 0,
            paddingLeft:0,
            paddingBottom: 10,
            paddingTop: 10,
            height: 320,
        },
    },
    details: {
        marginTop: 32,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 20,
        fontFamily: '"DM Sans", sans-serif',
    },
    pos: {
        marginBottom: 12,
    },
    dashboard: {
        background: theme.palette.primary.main,
        minHeight: 164,
        textAlign: 'center',
        borderRadius: 16,
        [theme.breakpoints.down('sm')]: {
            minHeight: 142,
        },
    }
}));


export default function Portfolio() {
    const history = useHistory();
    window.scrollTo(0, 0);
    const dispatch = useDispatch();
    //const [data, setData] = useState(undefined);
    const portfolioList = useSelector(store => store.portfolios?.list);
    const selectedIndex = useSelector(store => store.user.portfolio);
    const data = useSelector(store => store.portfolio?.data)
    const isLoadind = useSelector(store => store.portfolio?.isLoad)
    const portfolio = portfolioList[selectedIndex] || undefined
    const classes = useStyles();
    // useEffect(() => {
    //     //const service = new Service();
    //     // Не уверен что правильно делаю проверку
    //     //console.log(portfolio)
    //     if (portfolio?.id) {
    //         if(data?.portfolio.id != portfolio.id){
    //             console.log('обновили все данные')
    //             dispatch(getPortfolio(portfolio.id));
    //         }
    //         // service.getPortfolio(portfolio?.id).then(function (response) {
    //         //         //console.log(response)
    //         //        // setData(response)
    //         //     }
    //         // )
    //     }
    // }, [portfolio]);
    //console.log(portfolioList)
    //let {id} = useParams();


    return (
        <>

            {(isLoadind || data === undefined) &&
                    <div style={{display: 'flex', justifyContent: 'center', marginTop: '20%'}}>
                        <CircularProgress/>
                    </div>
            }

            {data !== undefined && _.isEmpty(data?.transactions) && !isLoadind &&
                <div style={{display: 'flex', justifyContent: 'center', marginTop: '20%'}}>
                    <div >
                        <Typography style={{textAlign: 'center'}} variant="h4" gutterBottom>Сделок пока нет</Typography><br/>
                        <EmptyPortfolio/>
                    </div>
                </div>
            }

            {!_.isEmpty(data?.transactions) && !isLoadind &&
                <Container style={{marginTop: 30,marginBottom: 70}}>
                    <Hidden smDown>
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-around"
                        alignItems="center"
                        className={classes.dashboard}
                        component={Box}
                    >
                        <Tooltip
                            title={
                                <React.Fragment>
                                    <Typography variant="body1">
                                        {Number(data?.money_input?.toFixed(2)).toLocaleString()} {getCurrencySymbol(data?.portfolio?.currency) || ''} внесли
                                    </Typography>
                                    <Typography variant="body1">
                                        {Number((-data?.money_output)?.toFixed(2)).toLocaleString()} {getCurrencySymbol(data?.portfolio?.currency) || ''} вывели
                                    </Typography>
                                    {/*<Typography variant="body1">В акциях {Number(data?.balance_share?.toFixed(2))?.toLocaleString()} {getCurrencySymbol(data?.portfolio?.currency) || ''}</Typography>*/}
                                    {/*<Typography variant="body1">В облигациях {Number(data?.balance_bond?.toFixed(2))?.toLocaleString()} {getCurrencySymbol(data?.portfolio?.currency) || ''}</Typography>*/}
                                </React.Fragment>
                            }
                        >
                            <Grid item className={classes.root}>
                                <Typography className={classes.title} gutterBottom>
                                    Суммарная стоимость
                                </Typography>
                                <Typography variant="h5" component="h2">
                                    {Number(data?.balance?.toFixed(2)).toLocaleString()} {getCurrencySymbol(data?.portfolio?.currency) || ''}
                                </Typography>

                            </Grid>
                        </Tooltip>
                        <Tooltip
                            title={
                                <React.Fragment>

                                    <Typography variant="body1">
                                        {Number(data?.results?.day?.dbalance.toFixed(2))?.toLocaleString()} {getCurrencySymbol(data?.portfolio?.currency) || ''} за день
                                    </Typography>
                                    <Typography variant="body1">
                                        {Number(data?.results?.month?.dbalance.toFixed(2))?.toLocaleString()} {getCurrencySymbol(data?.portfolio?.currency) || ''} за месяц
                                    </Typography>
                                    <Typography variant="body1">
                                        {Number(data?.results?.year?.dbalance.toFixed(2))?.toLocaleString()} {getCurrencySymbol(data?.portfolio?.currency) || ''} за год
                                    </Typography>
                                </React.Fragment>
                            }
                        >
                            <Grid item className={classes.root}>

                                <Typography className={classes.title} gutterBottom>
                                    Суммарная прибыль
                                </Typography>

                                <Typography variant="h5" component="h2" style={{color: data?.income_full >= 0 ? '#10B981' : '#EF4444'}}>
                                    {Number(data?.income_full?.toFixed(2)).toLocaleString()} {getCurrencySymbol(data?.portfolio?.currency) || ''}
                                </Typography>

                            </Grid>

                        </Tooltip>
                        <Tooltip
                            title={
                                <React.Fragment>
                                    <Typography variant="body1">
                                        Внутрення норма доходности
                                        (XIRR) {data?.xirr} %
                                    </Typography>
                                    <Typography variant="body1">
                                        Средняя годовая доходность
                                        (AAR) {data?.aar} %
                                    </Typography>
                                </React.Fragment>
                            }
                        >
                            <Grid item className={classes.root}>
                                <Typography className={classes.title} gutterBottom>
                                    Доходность
                                </Typography>
                                <Typography variant="h5" component="h2">
                                    {data?.xirr} %
                                </Typography>
                            </Grid>
                        </Tooltip>
                    </Grid>
                    </Hidden>

                    <Hidden mdUp>
                        <Grid
                            container
                            alignItems="center"
                            justifyContent="center"
                            className={classes.dashboard}
                            component={Box}
                        >
                                <Grid item className={classes.root}>

                                    <Typography variant="h5" component="h2">
                                        {Number(data?.balance?.toFixed(2)).toLocaleString()} {getCurrencySymbol(data?.portfolio?.currency) || ''}
                                    </Typography>
                                    <Typography variant="body2" component="p" style={{color: data?.income_full >= 0 ? '#10B981' : '#EF4444'}}>
                                        {Number(data?.income_full?.toFixed(2)).toLocaleString()} {getCurrencySymbol(data?.portfolio?.currency) || ''}
                                    </Typography>
                                    <Typography variant="body2" component="p">
                                        {data?.xirr} %
                                    </Typography>
                                </Grid>
                        </Grid>
                    </Hidden>
                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                    >
                        <Grid item component={Box} className={classes.pie}>
                            <PiePortfolio
                                portfolio={data}
                                currency={getCurrencySymbol(data?.portfolio?.currency) || ''}
                            />
                        </Grid>

                        <Grid item component={Box} className={classes.chart}>
                            <ChartPortfolio
                                data={_.map(data?.graph, 'b')}
                                category={_.map(data?.graph, 'd')}
                                series_title={'Стоимость'}
                                currency={getCurrencySymbol(data?.portfolio?.currency) || ''}
                            />
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                        className={classes.details}
                    >
                        <PortfolioDetails
                            portfolio={data}
                            currency={getCurrencySymbol(data?.portfolio?.currency) || ''}
                        />
                    </Grid>

                    <pre>
                        {/*JSON.stringify(data, null, 4)*/}
                    </pre>
                </Container>
            }
        </>
    )
}
